import { Component, OnInit } from '@angular/core';
import {
  GlobalMessageService,
  GlobalMessageType,
  OCC_CART_ID_CURRENT,
  TranslationService,
  User,
  UserIdService
} from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { tap, take, withLatestFrom, filter } from 'rxjs/operators';
import { UigCartService } from '../uig-cart.service';
import {ActiveCartService, getCartIdByUserId, MultiCartService} from "@spartacus/cart/base/core";

@Component({
    selector: 'app-uig-product-import',
    templateUrl: './uig-product-import.component.html',
    styleUrls: ['./uig-product-import.component.scss'],
    standalone: false
})
export class UigProductImportComponent implements OnInit {

  fileName = '';
  fileToBeImported: File;
  importFile$: Observable<Object>;
  isRestricted: boolean = false;
  RIO_CART_ORDER: string = "rio_cart_order";
  RIO_CART_CREATE_UPDATE: string = "rio_cart_create_update";
  roles: string[];
  private userSubscription = new Subscription();
  isImporting$ = new BehaviorSubject(false);

  constructor(
    private messageService: GlobalMessageService,
    private cartService: UigCartService,
    private activeCartService: ActiveCartService,
    private multiCartService: MultiCartService,
    private translationService: TranslationService,
    private userIdService: UserIdService,
    private userAccountFacade: UserAccountFacade) {

  }

  ngOnInit(): void {
    this.checkForRoles();
  }

  onSubmit() {
  }

  resetForm(): void {
  }

  onFileSelected(event: any) {
    this.fileToBeImported = event.target.files[0];
    if (this.fileToBeImported) {
      this.fileName = this.fileToBeImported.name;
    }
  }

  importFile():void{
    if(this.fileToBeImported){
      this.isImporting$.next(true);
      this.activeCartService.requireLoadedCart()
      .pipe(withLatestFrom(this.userIdService.getUserId()))
      .subscribe(([cartState, userId]) => {
        this.importFile$ = this.cartService.importFile(this.fileToBeImported,
          getCartIdByUserId(cartState, userId));
        this.importFile$
        .pipe(
          tap(
            (data) => {
              this.showMessage(data);
              this.isImporting$.next(false);
              window.scroll(0,0);
            }
          )
        )
        .subscribe((_res) => {
        });
      });
    }
    this.fileToBeImported = null;
    this.fileName = '';
  }


  showMessage (data: object): void{
    let response: Array<string> = data as Array<string>;
    const SHOW_MSG_TIMEOUT_INFO: number = 600000;

    if(response.length == 0){
      this.translationService
      .translate('productImport.importSuccess')
      .pipe(take(1))
      .subscribe((message) => {
        this.messageService.add(message, GlobalMessageType.MSG_TYPE_WARNING, SHOW_MSG_TIMEOUT_INFO);
      });
    }
    else if(response.length > 0){
      this.messageService.remove(GlobalMessageType.MSG_TYPE_WARNING);
      var errors = [];
      var warnings = [];
      for(var i = 0; i<response.length; i++) {
        var code: number  = Number(response[i].substring(1,4));
        var message = this.formatMessage(response[i]);
        if(code > 99) {
          errors.push(message);
        }
        else {
          warnings.push(message);
        }
      }
      if(warnings.length) {
        this.messageService.add(
          warnings.join("<br>"),
          GlobalMessageType.MSG_TYPE_WARNING,
          SHOW_MSG_TIMEOUT_INFO
        );
      }
      if(errors.length) {
        this.messageService.add(
          errors.join("<br>"),
          GlobalMessageType.MSG_TYPE_ERROR,
          SHOW_MSG_TIMEOUT_INFO
        );
      }
      
    }
    this.multiCartService.reloadCart(OCC_CART_ID_CURRENT);
  }

  ngOnDestroy(): void {
    this.userSubscription.unsubscribe();
  }

  formatMessage(message: string): string {
    var result: string;
    if (message[0]==='<') {
        result = message.substring(5);
    }
    else {
        result = message;
    }
    return result;
  }

  checkForRoles() {
    this.userSubscription = this.userAccountFacade
      .get()
      .pipe(filter((user: User) => user && Object.keys(user).length > 0))
      .subscribe((user) => {
        const hasRole =
          user.roles && (user.roles.includes(this.RIO_CART_CREATE_UPDATE)
            || user.roles.includes(this.RIO_CART_ORDER));
        if (!hasRole) {
          this.isRestricted = true;
        }
      });
  }
}
